module.exports = __webpack_public_path__ + "static/media/tradeCalc.60aee339.png";